/* eslint-disable import/no-anonymous-default-export */
export default (locationStock = [], action) => {
  switch (action.type) {
    case "LOCATION_STOCK":
      return action.payload;
    case "LOCATION_CREATE_STOCK":
      return [...locationStock, action.payload];

    default:
      return locationStock;
  }
};
